<template>
  <div class="progressPlan">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span style="font-size: 24px; margin-right: 50px"
          >协同进度计划管理</span
        >
        <el-button
          :type="planType == 2 ? 'success' : 'primary'"
          @click="changeType"
          >我发布的</el-button
        >
        <el-button
          :type="planType == 1 ? 'success' : 'primary'"
          @click="changeType"
          >我参与的</el-button
        >
        <el-button
          :type="planType == 3 ? 'success' : 'primary'"
          @click="changeType"
          >我审核的</el-button
        >
        <div class="head-text" style="float: right; margin-top: -4px">
          <!-- 新建事件 -->
          <el-input
            v-model="query"
            placeholder="请输入计划名称"
            class="search-input"
          ></el-input>
          <el-button
            slot="append"
            icon="el-icon-search"
            style="margin-right: 80px"
            @click="GetZjwjProjectPlan"
          ></el-button>
          <el-button type="primary" @click="ZjwjCopyPlan">复制</el-button>
          <el-button type="primary" @click="dialogVisibleOpen"
            >新增计划</el-button
          >
          <el-button v-if="planType == 2" type="danger" @click="ZjwjDelPlan"
            >删除</el-button
          >
        </div>
      </div>
      <div class="rygl-table">
        <el-table
          ref="multipleTable"
          :data="list"
          height="800px"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <el-table-column
            type="selection"
            align="center"
            width="55"
          ></el-table-column>
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            label="计划名称"
            align="center"
            prop="zwpp03"
          ></el-table-column>
          <el-table-column label="计划发起人" align="center" prop="zwpp09Name">
          </el-table-column>
          <el-table-column label="计划审核人" align="center" prop="zwpp11Name">
          </el-table-column>
          <el-table-column label="任务总审核" align="center" prop="shr">
          </el-table-column>
          <el-table-column label="任务总负责" align="center" prop="fzr">
          </el-table-column>
          <el-table-column
            label="计划开始时间"
            align="center"
            prop="zwpp04"
          ></el-table-column>
          <el-table-column
            label="计划结束时间"
            align="center"
            prop="zwpp05"
          ></el-table-column>
          <el-table-column
            label="最迟完成时间"
            align="center"
            prop="zwpp07"
          ></el-table-column>
          <el-table-column
            label="审核结束时间"
            align="center"
            prop="zwpp06"
          ></el-table-column>
          <el-table-column label="计划状态" align="center">
            <template slot-scope="scope">
              <span
                :style="{
                  color:
                    scope.row.zwpp12 == 0
                      ? '#00bfbf'
                      : scope.row.zwpp12 == 1
                      ? '#8080ff'
                      : scope.row.zwpp12 == 2
                      ? '#00bfbf'
                      : '#f00',
                }"
                >{{
                  scope.row.zwpp12 == 0
                    ? "新建"
                    : scope.row.zwpp12 == 1
                    ? "审核中"
                    : scope.row.zwpp12 == 2
                    ? "已完成"
                    : "驳回"
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            align="center"
            prop="zwpp10"
          ></el-table-column>

          <el-table-column label="操作" align="center" prop="h" width="200">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                plain
                @click="view(scope.row)"
                >详情</el-button
              >
              <el-button
                type="primary"
                plain
                size="small"
                @click="editor(scope.row)"
                v-if="
                  (id == scope.row.zwpp09 &&
                    (scope.row.zwpp12 == 0 || scope.row.zwpp12 == 3)) ||
                  (!scope.row.zwpp11 && scope.row.zwpp12 == 2)
                "
                >修改</el-button
              >
              <el-button
                type="primary"
                plain
                size="small"
                @click="audit(scope.row)"
                v-if="planType == 3"
                >审核</el-button
              ><el-button
                type="primary"
                plain
                size="small"
                @click="auditDetail(scope.row)"
                v-if="
                  (scope.row.zwpp12 == 2 || scope.row.zwpp12 == 3) &&
                  scope.row.zwpp11
                "
                >审核详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        style="margin-top: 30px"
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 新增 -->
    <el-dialog
      :title="myTitle"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-form
        ref="form"
        :model="zjwj_projectplan"
        label-width="100px"
        :rules="addPlanRules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="计划名称">
              <el-input
                v-model="zjwj_projectplan.zwpp03"
                style="width: 80%"
                placeholder="请输入计划名称"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="计划开始时间">
              <el-date-picker
                v-model="zjwj_projectplan.zwpp04"
                type="datetime"
                placeholder="选择日期时间"
                @change="(time) => changTime(time, 1)"
                value-format="yyyy/MM/dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="计划审核人">
              <el-select filterable clearable v-model="zjwj_projectplan.zwpp11">
                <el-option
                  :label="item.user04"
                  :title="item.user02"
                  :value="item.user01"
                  v-for="item in userList2"
                  :key="item.user01"
                  v-show="item.user01 != id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划结束时间">
              <el-date-picker
                v-model="zjwj_projectplan.zwpp05"
                type="datetime"
                placeholder="选择日期时间"
                @change="(time) => changTime(time, 2)"
                value-format="yyyy/MM/dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="任务总负责">
              <el-select
                filterable
                v-model="fzList"
                @change="changeUser"
                multiple
                @remove-tag="removetag"
              >
                <el-option
                  :label="item.user04"
                  :title="item.user02"
                  :value="item.user01"
                  v-for="item in userList"
                  :key="item.user01"
                  v-show="item.isSelect === false"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最迟完成时间">
              <el-date-picker
                v-model="zjwj_projectplan.zwpp07"
                type="datetime"
                placeholder="最迟完成时间"
                @change="(time) => changTime(time, 4)"
                value-format="yyyy/MM/dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="任务总审核">
              <el-select
                filterable
                v-model="shList"
                multiple
                @change="changeUser"
                @remove-tag="removetag"
              >
                <el-option
                  :label="item.user04"
                  :title="item.user02"
                  :value="item.user01"
                  :key="item.user01"
                  v-for="item in userList"
                  v-show="item.isSelect === false"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"
            ><el-form-item label="审核结束时间">
              <el-date-picker
                v-model="zjwj_projectplan.zwpp06"
                type="datetime"
                placeholder="选择日期时间"
                @change="(time) => changTime(time, 3)"
                value-format="yyyy/MM/dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="zjwj_projectplan.zwpp08"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-row>
        <el-col :span="3" :offset="8">
          <el-button style="width: 100%" @click="AddOrUpdateZjwjProjectPlan"
            >确定</el-button
          >
        </el-col>
        <el-col :span="3" :offset="1">
          <el-button style="width: 100%" @click="closeDialog">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 提交审核 -->
    <el-dialog
      :close-on-click-modal="false"
      title="审核意见"
      :visible.sync="auditOpen"
      width="30%"
    >
      <el-input
        v-model="zjwj_planaudit.plau05"
        type="textarea"
        :rows="4"
        placeholder="请输入审核建议内容"
      ></el-input>
      <el-row style="text-align: center">
        <el-col :span="12">
          <el-button type="danger" @click="PlanSubmitAudit">驳回</el-button>
        </el-col>
        <el-col :span="12"
          ><el-button type="success" @click="PlanSubmitAudit"
            >通过</el-button
          ></el-col
        >
      </el-row>
    </el-dialog>
    <!-- 审核详情 -->
    <el-dialog
      :close-on-click-modal="false"
      title="审核意见"
      :visible.sync="auditDetailOpen"
      width="30%"
    >
      <el-card
        class="box-card"
        style="margin-bottom: 20px"
        v-for="item in AuditData"
        :key="item.plau01"
      >
        <el-row style="padding: 0">
          <el-col :span="14">
            <h2>{{ item.plau03Name }}</h2></el-col
          >
          <el-col :span="8">
            <p>{{ item.plau06 }}</p></el-col
          >
        </el-row>
        <p style="color: red; padding: 5px">{{ item.plau05 }}</p>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import {
  GetAuditUserList2,
  AddOrUpdateZjwjProjectPlan, // 添加修改计划
  GetZjwjOneProjectPlan, //获取单个项目计划
  GetZjwjProjectPlan, //获取项目计划
  GetZjwjPlanDetailTime,
  PlanSubmitAudit,
  GetPlanSubmitAudit,
  ZjwjDelPlan,
  ZjwjCopyPlan,
} from "@/setAxios";
export default {
  name: "progressPlan",
  data() {
    return {
      addPlanRules: {
        zwpp03: [
          { required: true, message: "请输入计划名称", trigger: "blur" },
        ],
      },
      auditOpen: false,
      zjwj_planaudit: {
        plau01: "",
        plau02: "",
        plau03: "",
        plau04: "",
        plau05: "",
        plau06: "",
      },
      auditDetailOpen: false,
      loading: false,
      myTitle: "新增",
      options: [],
      query: "",
      dialogVisible: false,
      dialogVisible2: false,
      list: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      zjwj_projectplan: {
        zwpp01: "",
        zwpp02: localStorage.xid,
        zwpp03: "",
        zwpp04: "",
        zwpp05: "",
        zwpp06: "",
        zwpp07: "",
        zwpp08: "",
        zwpp09: localStorage.id,
        zwpp10: "",
        zwpp11: "",
        zwpp12: "",
      },
      userList: [],
      userList2: [],
      fzList: [],
      shList: [],
      planType: 2,
      // 这里是用户ID
      id: 0,
      AuditData: [],
      //高亮
      planid: "",
      planIdArr: [],
      planId2: "",
      userId: "",
    };
  },
  created() {
    this.id = localStorage.id;
    this.GetZjwjProjectPlan();
  },
  methods: {
    ZjwjCopyPlan() {
      this.$confirm("确定复制所勾选节点？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let idsArr = [];
        this.planIdArr.forEach((ele) => {
          idsArr.push(ele.zwpp01);
        });
        let params = {
          ids: idsArr.join(","),
        };
        let res = await ZjwjCopyPlan(params);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "复制成功!",
          });
          this.planIdArr = [];
          this.GetZjwjProjectPlan();
        }
      });
    },
    ZjwjDelPlan() {
      this.$confirm("将会清除一切记录?, 是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        console.log(this.planIdArr);
        let idsArr = [];
        this.planIdArr.forEach((ele) => {
          idsArr.push(ele.zwpp01);
        });
        let params = {
          ids: idsArr.join(","),
        };
        let res = await ZjwjDelPlan(params);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.planIdArr = [];
          this.GetZjwjProjectPlan();
        }
      });
    },
    audit(data) {
      this.zjwj_planaudit.plau02 = data.zwpp01;
      this.zjwj_planaudit.plau03 = localStorage.id;
      this.auditOpen = true;
    },
    async PlanSubmitAudit(e) {
      if (e.target.innerText == "驳回") {
        this.zjwj_planaudit.plau04 = 0;
      } else {
        this.zjwj_planaudit.plau04 = 1;
      }
      this.zjwj_planaudit.plau06 = new Date();
      let res = await PlanSubmitAudit({ model: this.zjwj_planaudit });
      if (res.Code > 0) {
        if (e.target.innerText == "驳回") {
          this.$message({
            type: "success",
            message: "驳回成功",
          });
        } else {
          this.$message({
            type: "success",
            message: "通过成功",
          });
        }
        this.auditOpen = false;
        this.GetZjwjProjectPlan();
      }
    },
    async auditDetail(data) {
      this.auditDetailOpen = true;
      let params = {
        planid: data.zwpp01,
      };
      let res = await GetPlanSubmitAudit({ params });
      this.AuditData = res.Data;
    },
    changeType(e) {
      if (e.target.innerText == "我发布的") {
        this.planType = 2;
        this.GetZjwjProjectPlan();
      } else if (e.target.innerText == "我参与的") {
        this.planType = 1;
        this.GetZjwjProjectPlan();
      } else if (e.target.innerText == "我审核的") {
        this.planType = 3;
        this.GetZjwjProjectPlan();
      }
    },
    closeDialog() {
      this.dialogVisible = false;
      this.myTitle = "新增";
    },
    reset() {
      this.zjwj_projectplan = {
        zwpp01: "",
        zwpp02: localStorage.xid,
        zwpp03: "",
        zwpp04: "",
        zwpp05: "",
        zwpp06: "",
        zwpp07: "",
        zwpp08: "",
        zwpp09: localStorage.id,
        zwpp10: "",
        zwpp11: "",
        zwpp12: "",
      };
      this.fzList = [];
      this.shList = [];
    },
    async GetZjwjProjectPlan() {
      this.loading = true;
      let params = {
        id: localStorage.xid,
        searchword: this.query,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        type: this.planType,
      };
      if (this.$route.params.id) {
        this.planid = this.$route.params.id;
        this.glid = this.$route.params.ids;
        let res = await GetZjwjProjectPlan({ params });
        this.list = res.Data.list;
        this.list.forEach((ele) => {
          ele.fzId = ele.fzList.length > 0 ? ele.fzList[0].user01 : "";
          ele.shId = ele.shList.length > 0 ? ele.shList[0].user01 : "";
          // ---------
          ele.fzr = [];
          ele.fzList.forEach((ele2) => {
            ele.fzr.push(ele2.user04);
          });
          ele.fzr = ele.fzr.join(",");
          ele.shr = [];
          ele.shList.forEach((ele2) => {
            ele.shr.push(ele2.user04);
          });
          ele.shr = ele.shr.join(",");
          // --------
        });
        this.total = res.Data.total;
        this.loading = false;
      } else {
        let res = await GetZjwjProjectPlan({ params });
        this.list = res.Data.list;
        this.list.forEach((ele) => {
          ele.fzId = ele.fzList.length > 0 ? ele.fzList[0].user01 : "";
          ele.shId = ele.shList.length > 0 ? ele.shList[0].user01 : "";
          // ---------
          ele.fzr = [];
          ele.fzList.forEach((ele2) => {
            ele.fzr.push(ele2.user04);
          });
          ele.fzr = ele.fzr.join(",");
          ele.shr = [];
          ele.shList.forEach((ele2) => {
            ele.shr.push(ele2.user04);
          });
          ele.shr = ele.shr.join(",");
          // --------
        });
        this.total = res.Data.total;
        this.loading = false;
      }
    },
    //高亮
    tableRowClassName({ row, rowIndex }) {
      let findIndex = this.list.findIndex((ele) => ele.zwpp01 == this.planid);
      if (rowIndex == findIndex) {
        return "success-row";
      }
      return "";
    },
    //---
    changTime(time, type) {},
    async AddOrUpdateZjwjProjectPlan() {
      let isPass = true;
      let a = new Date(Date.parse(this.zjwj_projectplan.zwpp04));
      let b = new Date(Date.parse(this.zjwj_projectplan.zwpp05));
      let c = new Date(Date.parse(this.zjwj_projectplan.zwpp07));
      let d = new Date(Date.parse(this.zjwj_projectplan.zwpp06));
      if (this.myTitle == "修改") {
        let res = await GetZjwjPlanDetailTime({
          params: { planid: this.zjwj_projectplan.zwpp01 },
        });
        if (res.Data) {
          let arr = res.Data;
          arr.time1 = new Date(Date.parse(arr.time1));
          arr.time2 = new Date(Date.parse(arr.time2));
          arr.time3 = new Date(Date.parse(arr.time3));
          arr.time4 = new Date(Date.parse(arr.time4));
          a <= arr.time1 && b >= arr.time2 && c >= arr.time3 && d >= arr.time4
            ? (isPass = true)
            : (isPass = false);
        } else {
          a <= b && b <= c && c <= d ? (isPass = true) : (isPass = false);
        }
      } else {
        a <= b && b <= c && c <= d ? (isPass = true) : (isPass = false);
      }
      if (isPass === false) {
        this.$message({
          type: "danger",
          message: "时间选择错误",
        });
        return false;
      }

      this.zjwj_projectplan.zwpp10 = new Date();
      if (this.zjwj_projectplan.zwpp11 == "") {
        this.zjwj_projectplan.zwpp12 = 2;
      } else {
        this.zjwj_projectplan.zwpp12 = 0;
      }
      if (this.fzList.length > 0 && this.shList.length > 0) {
        let params = {
          model: this.zjwj_projectplan,
          fzList: this.fzList,
          shList: this.shList,
        };
        let res = await AddOrUpdateZjwjProjectPlan(params);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "处理成功",
          });
          this.dialogVisible = false;
          this.myTitle = "新增";
          this.GetZjwjProjectPlan();
        } else {
          this.$message({
            type: "warning",
            message: res.Message,
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请选择任务总负责和任务总审核",
        });
      }
    },
    removetag(data) {
      let findId = this.userList.findIndex((ele) => ele.user01 == data);
      this.userList[findId].isSelect = false;
    },
    changeUser(data) {
      data.reduce((newobj, key) => {
        let findId = this.userList.findIndex((ele) => ele.user01 == key);
        this.$set(this.userList[findId], "isSelect", true);
      }, this.userList);
    },
    view(data) {
      var code = `planid=${data.zwpp01}&codeData01=${data.zwpp04}&codeData02=${data.zwpp05}&codeData03=${data.zwpp07}&codeData04=${data.zwpp06}&planName=${data.zwpp03}&zwpp12=${data.zwpp12}&zwpp11=${data.zwpp11}`;
      code = Base64.encode(code);
      this.$router.push({
        path: "/plansDetails",
        query: {
          code,
        },
      });
    },
    async editor(data) {
      this.myTitle = "修改";
      this.reset();
      this.zjwj_projectplan = data;
      let ids = "";
      let userIdSelectArr = [
        ...this.zjwj_projectplan.fzList,
        ...this.zjwj_projectplan.shList,
      ];
      this.zjwj_projectplan.fzList.forEach((ele) => {
        this.fzList.push(ele.user01);
      });
      this.zjwj_projectplan.shList.forEach((ele) => {
        this.shList.push(ele.user01);
      });
      if (this.zjwj_projectplan.zwpp11) {
        this.zjwj_projectplan.zwpp11 = Number(this.zjwj_projectplan.zwpp11);
      } else {
        this.zjwj_projectplan.zwpp11 = "";
      }
      let params = {
        xid: localStorage.xid,
        qid: localStorage.pid,
        ids: "",
      };
      let res = await GetAuditUserList2(params);
      this.userList = res.Data;
      this.userList2 = _.cloneDeep(res.Data);
      this.userList.forEach((ele) => {
        ele.isSelect = false;
      });
      let newData = [...this.shList, ...this.fzList];
      for (let i = 0; i < newData.length; i++) {
        for (let j = 0; j < this.userList.length; j++) {
          if (i.user01 == j.user01) {
            this.userList[j].isSelect = true;
            continue;
          }
        }
      }

      // newData.reduce((newObj, key) => {
      //   let findId = this.userList.findIndex((ele) => ele.user01 == key);
      //   this.$set(this.userList[findId], "isSelect", true);
      // }, this.userList);
      this.dialogVisible = true;
    },
    async dialogVisibleOpen() {
      this.dialogVisible = true;
      let ids = "";
      this.reset();
      this.GetAuditUserList2(ids);
    },
    async GetAuditUserList2(ids, data) {
      let params = {
        xid: localStorage.xid,
        qid: localStorage.pid,
        ids: ids,
      };
      let res = await GetAuditUserList2(params);
      this.userList = res.Data;
      this.userList2 = _.cloneDeep(res.Data);
      this.userList.forEach((ele) => {
        ele.isSelect = false;
      });
    },
    handleSelectionChange(val) {
      this.planIdArr = val;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetZjwjProjectPlan();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetZjwjProjectPlan();
    },
  },
};
</script>

<style lang="less" scoped>
.search-input {
  width: 300px;
}
</style>
<style lang="less" scoped>
/deep/.el-table .success-row {
  background: skyblue;
}
</style>